import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../supabase/supabaseClient";

function ScoutRoute({ children }) {
    const [loading, setLoading] = useState(true);
    const [allowed, setAllowed] = useState(false);

    useEffect(() => {
        const checkRole = async () => {
            const { data } = await supabase.auth.getSession();
            const user = data?.session?.user ?? null;
            if (!user) {
                setAllowed(false);
                setLoading(false);
                return;
            }

            // Prefer server-side canonical role from `user_profiles` when available
            try {
                const { data: upData, error: upErr } = await supabase
                    .from("user_profiles")
                    .select("role")
                    .eq("user_id", user.id)
                    .maybeSingle();
                if (!upErr && upData && upData.role) {
                    const role = upData.role.toString().toLowerCase();
                    setAllowed(role === "scout" || role === "coach");
                    setLoading(false);
                    return;
                }
            } catch (e) {
                console.error("ScoutRoute: error fetching user_profiles role", e);
            }

            // Fallback to auth metadata
            const metaRole = user?.user_metadata?.role;
            setAllowed(!!metaRole && (metaRole.toString().toLowerCase() === "scout" || metaRole.toString().toLowerCase() === "coach"));
            setLoading(false);
        };
        checkRole();
    }, []);

    if (loading) return null;
    return allowed ? children : <Navigate to="/login" replace />;
}

export default ScoutRoute;
